module.exports = __webpack_public_path__ + "img/chicken.2ad0dd82.jpg";